import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";

import FilterForm from "app/Components/FilterForm/FilterForm";
import { useArea, useCategory, useContractorDropdown } from "app/_helpers/hooks";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
//import { UserService } from "app/_services/UserService/UserService";
//import { LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";
import { LOGGED_IN_USER_SITE_ID } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { UserService } from "app/_services/UserService/UserService";
import {
  TRAINEE_TYPE,
  trainingbatchFilterFields,
  trainingStatusFilterFields,
} from "../../CONSTANTS";
import { getContractor } from "app/_services/Contractor/ContractorService";

export default function TrainingBatchFilters({ form, onChange, onReset, setForm }) {
  const [state, setState] = useState({
    sites: [],
  });

  const [category, categoryOption] = useCategory("filter[source]=training");
  const [contractors, contractorOption] = useContractorDropdown();

  useEffect(() => {
    getAllSites("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setState((prev) => ({
        ...prev,
        //initialActivity: response?.data,
        sites: response.data.map((row) => ({ label: row.name, value: row.id })),
      }));
    });
  }, []);

  const fields = useMemo(
    () =>
      trainingbatchFilterFields.map((f) => {
        const field = { ...f };

        switch (field.name) {
          case "trainingCategoryId":
            field.options = categoryOption;
            break;
          case "siteId":
            field.options = state.sites;
            break;
          case "contractorId":
            field.options = contractorOption;
            break;
          default:
            break;
        }

        return field;
      }),
    [categoryOption, contractorOption, state.sites]
  );

  const handleDateRange = (dates) => {
    console.log("dates", dates);
    onChange({
      target: {
        name: "startDate",
        value: dates.startDate
          ? moment(new Date(dates.startDate)).format("YYYY-MM-DD")
          : null,
      },
    });
    onChange({
      target: {
        name: "endDate",
        value: dates.endDate
          ? moment(new Date(dates.endDate)).format("YYYY-MM-DD")
          : null,
      },
    });
  };

  return (
    <div className="pb-4">
      <FilterForm
        fields={fields}
        form={form}
        onChange={onChange}
        onReset={onReset}
        handleDateRange={handleDateRange}
        startDate={form?.startDate || null}
        endDate={form?.endDate || null}
      />
    </div>
  );
}
